module.exports = __webpack_public_path__ + "static/1-013-4217b595409d8332c7ef12869041f15b.png";